// extracted by mini-css-extract-plugin
export var locationCard = "_s0-0";